<template>
  <el-dialog
    custom-class="screen-dialog"
    title="工单详情"
    :visible.sync="dialogVisible"
    width="760px"
    append-to-body
    @close="onClose"
  >
    <div v-loading="loading" element-loading-background="rgba(2,11,26,0.55)" class="detail-body">
      <template v-if="detail">
        <div class="detail-hero">
          <div class="hero-label">WORK ORDER</div>
          <div class="hero-id">{{ detail.workOrderId || "-" }}</div>
          <div class="hero-meta">
            <el-tag :style="statusTagStyle(detail.workOrderStatus)" size="small">
              {{ statusLabel(detail.workOrderStatus) }}
            </el-tag>
            <span class="hero-chip">{{ urgencyLabel(detail.urgencyLevel) }}</span>
            <span class="hero-chip muted">{{ progressLabel(detail.progressNode) }}</span>
          </div>
        </div>

        <el-descriptions class="screen-desc" :column="2" border size="medium">
          <el-descriptions-item label="客户">
            <span class="val-strong">{{ detail.customerName || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="设备ID">
            <span class="val-mono accent">{{ detail.deviceId || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="设备">
            <span class="val-strong">{{ detail.deviceName || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="设备型号">
            <span class="val-strong">{{ detail.deviceModel || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="地址" :span="2">
            <span class="val-text">{{ detail.address || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="售后人员">
            <span class="val-strong">{{ detail.aftersaleName || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <span class="val-mono accent">{{ detail.aftersalePhone || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="提单时间">
            <span class="val-mono">{{ detail.submitTime || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="接单时间">
            <span class="val-mono">{{ detail.acceptTime || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="故障类型" :span="2">
            <span class="val-warn">{{ detail.faultType || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="故障描述" :span="2">
            <span class="val-text">{{ detail.faultDescription || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="备件备注" :span="2">
            <span class="val-text">{{ detail.partsRemark || "-" }}</span>
          </el-descriptions-item>
        </el-descriptions>

        <div v-if="detail.faultImageUrls && detail.faultImageUrls.length" class="section">
          <div class="section-title"><i class="title-bar"></i>故障图片</div>
          <div class="media-row">
            <el-image
              v-for="(url, i) in detail.faultImageUrls"
              :key="'img-' + i"
              :src="url"
              :preview-src-list="detail.faultImageUrls"
              fit="cover"
              class="media-img"
            ></el-image>
          </div>
        </div>

        <div v-if="detail.faultVideoUrls && detail.faultVideoUrls.length" class="section">
          <div class="section-title"><i class="title-bar"></i>故障视频</div>
          <div class="media-row">
            <video
              v-for="(url, i) in detail.faultVideoUrls"
              :key="'fv-' + i"
              class="media-video"
              :src="url"
              controls
            ></video>
          </div>
        </div>

        <div v-if="detail.repairRecords && detail.repairRecords.length" class="section">
          <div class="section-title"><i class="title-bar"></i>维修记录</div>
          <el-timeline>
            <el-timeline-item
              v-for="(rec, i) in detail.repairRecords"
              :key="i"
              :timestamp="rec.uploadTime"
              placement="top"
              color="#00e5ff"
            >
              <p class="record-line">
                <b class="record-name">{{ rec.uploaderName || "-" }}</b>
                <span class="record-sep">·</span>
                <span class="record-comment">{{ rec.comment || "-" }}</span>
              </p>
              <div class="media-row" v-if="rec.imageUrls && rec.imageUrls.length">
                <el-image
                  v-for="(url, j) in rec.imageUrls"
                  :key="'r-' + i + '-' + j"
                  :src="url"
                  :preview-src-list="rec.imageUrls"
                  fit="cover"
                  class="media-img"
                ></el-image>
              </div>
              <div class="media-row" v-if="rec.videoUrls && rec.videoUrls.length">
                <video
                  v-for="(url, j) in rec.videoUrls"
                  :key="'rv-' + i + '-' + j"
                  class="media-video"
                  :src="url"
                  controls
                ></video>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </template>
      <div v-else-if="!loading" class="empty-tip">暂无详情</div>
    </div>
  </el-dialog>
</template>

<script>
import {
  statusLabel,
  urgencyLabel,
  progressLabel,
  statusTagStyle,
} from "@/common/js/workOrderDict";

export default {
  name: "workOrderDetailDialog",
  props: {
    visible: Boolean,
    detail: Object,
    loading: Boolean,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    statusLabel,
    urgencyLabel,
    progressLabel,
    statusTagStyle,
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/screen-theme.scss";

.detail-body {
  min-height: 200px;
  max-height: 70vh;
  overflow-y: auto;
  color: $screen-text;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans SC", sans-serif;
  font-size: 14px;
  line-height: 1.65;
}

.detail-hero {
  margin-bottom: 18px;
  padding: 16px 18px 14px;
  background:
    linear-gradient(120deg, rgba(0, 140, 200, 0.28), rgba(0, 40, 80, 0.12) 55%, transparent),
    rgba(0, 40, 70, 0.45);
  border: 1px solid $screen-border;
  border-left: 3px solid $screen-cyan;
  box-shadow: inset 0 0 20px rgba(0, 160, 255, 0.08);
}

.hero-label {
  font-size: 12px;
  letter-spacing: 3px;
  color: $screen-cyan;
  margin-bottom: 6px;
  opacity: 0.85;
}

.hero-id {
  font-size: 22px;
  font-weight: 700;
  color: $screen-text;
  letter-spacing: 1px;
  line-height: 1.3;
  text-shadow: 0 0 12px rgba(0, 229, 255, 0.45);
}

.hero-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.hero-chip {
  font-size: 13px;
  font-weight: 600;
  color: $screen-cyan;
  padding: 3px 10px;
  border: 1px solid rgba(0, 229, 255, 0.45);
  background: rgba(0, 120, 180, 0.22);
}

.hero-chip.muted {
  color: $screen-text-dim;
  border-color: rgba(142, 182, 208, 0.4);
  background: rgba(0, 60, 100, 0.25);
}

.val-strong {
  font-weight: 700;
  font-size: 15px;
  color: $screen-text;
}

.val-sub {
  color: $screen-text-dim;
  font-weight: 400;
  font-size: 14px;
}

.val-text {
  color: #e8f4ff;
  font-weight: 500;
  font-size: 15px;
}

.val-mono {
  font-family: "Consolas", "Courier New", monospace;
  font-size: 15px;
  font-weight: 600;
  color: #c9e7ff;
}

.val-mono.accent {
  color: $screen-cyan;
  font-size: 16px;
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.35);
}

.val-warn {
  font-weight: 700;
  font-size: 15px;
  color: $screen-warn;
}

.section {
  margin-top: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 12px;
  color: $screen-text;
  letter-spacing: 1px;
}

.title-bar {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: linear-gradient(180deg, $screen-cyan, $screen-blue);
  box-shadow: 0 0 8px $screen-cyan-glow;
}

.media-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.media-img {
  width: 96px;
  height: 96px;
  border-radius: 2px;
  border: 1px solid rgba(0, 229, 255, 0.45);
  box-shadow: 0 0 8px rgba(0, 180, 255, 0.2);
}

.media-video {
  width: 220px;
  height: 130px;
  border-radius: 2px;
  border: 1px solid rgba(0, 229, 255, 0.45);
  background: #000;
}

.record-line {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.6;
}

.record-name {
  font-weight: 700;
  color: $screen-cyan;
}

.record-sep {
  margin: 0 6px;
  color: rgba(0, 229, 255, 0.45);
}

.record-comment {
  color: #e8f4ff;
  font-weight: 400;
}

.empty-tip {
  text-align: center;
  padding: 40px;
  color: $screen-text-dim;
  font-size: 15px;
}
</style>

<style lang="scss">
@import "../css/screen-theme.scss";

.screen-dialog {
  background: rgba(4, 16, 36, 0.96) !important;
  border: 1px solid $screen-border !important;
  box-shadow:
    0 0 28px rgba(0, 180, 255, 0.35),
    inset 0 0 24px rgba(0, 120, 200, 0.08) !important;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans SC", sans-serif;
}

.screen-dialog .el-dialog__header {
  background: $screen-header-bar;
  border-bottom: 1px solid rgba(0, 229, 255, 0.35);
  padding: 14px 20px;
}

.screen-dialog .el-dialog__title {
  font-size: 17px;
  font-weight: 700;
  color: $screen-text;
  letter-spacing: 3px;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.5);
}

.screen-dialog .el-dialog__headerbtn .el-dialog__close {
  color: $screen-cyan;
  font-size: 18px;
}

.screen-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: $screen-text;
}

.screen-dialog .el-dialog__body {
  background: rgba(4, 16, 36, 0.96);
  color: #e8f4ff;
  padding: 18px 20px 24px;
}

.screen-dialog .el-descriptions {
  color: #e8f4ff;
}

.screen-dialog .el-descriptions .el-descriptions__body {
  background: transparent;
}

.screen-dialog .el-descriptions-item__label.is-bordered-label {
  background: rgba(0, 100, 140, 0.75) !important;
  color: $screen-text !important;
  border-color: rgba(0, 180, 220, 0.35) !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  letter-spacing: 1px !important;
  line-height: 1.55 !important;
  width: 96px !important;
  min-width: 96px !important;
}

.screen-dialog .el-descriptions-item__content {
  background: rgba(0, 40, 70, 0.45) !important;
  color: $screen-text !important;
  border-color: rgba(0, 180, 220, 0.3) !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 1.6 !important;
}

.screen-dialog .el-timeline-item__timestamp {
  font-size: 13px !important;
  color: #7ec8e8 !important;
}

.screen-dialog .el-timeline-item__content {
  color: #e8f4ff;
}

.screen-dialog .el-timeline-item__node {
  background-color: $screen-cyan !important;
}
</style>
